module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-down-+i.e7b2d6e5.svg";